import type { JSX } from 'react';
import { FormGroup } from '@ksyos/design-system';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import { AssetCategory, FilesUrlBase } from '@common/enums';
import { RenderAssetThumbnails } from '@frontend/components/pages/episodes/common';
import { useProcessActivityReadContext } from '@frontend/utils';

type ProcessActivityAssetsDropzoneReadProps = Readonly<{
    assets: ProcessActivityAsset[];
    label: string;
}>;

export function ProcessActivityAssetsRead(props: ProcessActivityAssetsDropzoneReadProps): JSX.Element | null {
    const { processActivity } = useProcessActivityReadContext();
    const assets = props.assets.filter((asset) => asset.category !== AssetCategory.removed);

    if (!assets.length) {
        return null;
    }

    return (
        <AssetThumbnails
            assets={assets}
            id={processActivity.id}
            label={props.label}
        />
    );
}

export function AssetThumbnails(
    props: Readonly<{
        assets: ProcessActivityAsset[];
        id?: string;
        label: string;
    }>
) {
    const { assets, id, label } = props;

    return (
        <FormGroup label={label}>
            <RenderAssetThumbnails
                assets={assets}
                id={id}
                urlBase={FilesUrlBase.processActivities}
            />
        </FormGroup>
    );
}
